import React, {useEffect, useState} from 'react';
import Icn from "../../components/Icn";
import Tx from "../../components/Tx";
import PageTitle from "../../components/PageTitle";
import styled from "styled-components";
import AsideFirmwareMenu, {ASIDE_TYPES} from "../../components/firmware/AsideFirmwareMenu";
import UploadFirmware from "../../components/firmware/UploadFirmware";
import SensorManufacturerType from "../../components/firmware/SensorManufacturerType";
import {api} from "../../maps/data.js";
import ListOfFirmwares from "../../components/firmware/ListOfFirmwares";

const WrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 250px auto;
    grid-gap: 30px;
`;

const ContentWrapperStyled = styled.div`

`;

const FirmwarePage = () => {
    const [selectedMenuItem, s_selectedMenuItem] = useState(ASIDE_TYPES.LIST_OF_FIRMWARES);
    const [sensorModels, s_sensorModels] = useState([]);
    const [firmwareData, s_firmwareData] = useState([]);

    useEffect(() => {
        getSensorModels();
        getFirmwares();
    }, []);

    const getFirmwares = async () => {
        api({
            type: "getFirmware"
        }).then(data => {
            s_firmwareData(data);
        }).catch(e => {
            console.error(e);
        });
    };
    const getSensorModels = async () => {
        api({
            type: "getSensorModels"
        }).then(data => {
            s_sensorModels(data);
        }).catch(e => {
            console.error(e);
        });
    };

    const handleFirmwareDelete = (id) => {
        api({
            type: "deleteFirmware",
            data: {id}
        }).then(data => {
            getFirmwares();
        }).catch(e => {
            console.error(e);
        });
    };

    const handleActiveFirmware = (id) => {
        api({
            type: "editFirmware",
            data: {id, active: true}
        }).then(data => {
            getFirmwares();
        }).catch(e => {
            console.error(e);
        });
    }

    return (
        <div style={{height: '100%', overflowY: 'scroll', padding: 20}}>
            <PageTitle>
                <div style={{position: 'relative'}}>
                    <Icn>confirmationNumberIcon</Icn> <Tx>menu.firmware</Tx>
                </div>
            </PageTitle>
            <WrapperStyled>
                <AsideFirmwareMenu
                    selected={selectedMenuItem}
                    onSelectHandle={(menuItem) => {
                        s_selectedMenuItem(menuItem);
                    }}
                />
                <ContentWrapperStyled>
                    {selectedMenuItem === ASIDE_TYPES.LIST_OF_FIRMWARES && (
                        <ListOfFirmwares
                            sensorModels={sensorModels}
                            firmwareData={firmwareData}
                            handleFirmwareDelete={handleFirmwareDelete}
                            handleActiveFirmware={handleActiveFirmware}
                        />
                    )}
                    {selectedMenuItem === ASIDE_TYPES.UPLOAD_FIRMWARE && (
                        <UploadFirmware
                            sensorModels={sensorModels}
                            forceGetList={() => {
                                getFirmwares();
                                getSensorModels();
                            }}
                        />
                    )}
                    {selectedMenuItem === ASIDE_TYPES.SENSOR_MANUFACTURER_TYPE && (
                        <SensorManufacturerType
                            sensorModels={sensorModels}
                            forceModelsUpdate={() => {
                                getSensorModels();
                            }}
                        />
                    )}
                </ContentWrapperStyled>
            </WrapperStyled>
        </div>
    );
};

export default FirmwarePage;